<template>
  <div v-if="passwordResetState.inProgress" class="fullscreenCenteredContainer">
    <LoadingSpinner size="large" style="margin-bottom: 10px"/>
    <h1 class="subtitle">Please wait...</h1>
  </div>

  <ModalDialog
    :active="!passwordResetState.inProgress"
    :title="isNewAccount=='true' ? 'Choose Your Password' : 'Reset Password'"
    :first-button-text="isNewAccount=='true' ? 'Set Password' : 'Reset Password'"
    first-button-severity="primary"
    @firstbuttonselected="resetPassword()"
  >
    <div>
      <FormTextField label="Please enter your new password" placeholder="Password" :isPassword="true" v-model="passwordResetState.password"/>
      <FormTextField label="Repeat Password" placeholder="Repeat Password" :isPassword="true" v-model="passwordResetState.repeatPassword"/>
    </div>
    
  </ModalDialog>
</template>

<script lang="ts" setup>
import { reactive, getCurrentInstance, onMounted } from "vue";
import { useRoute } from "vue-router";
import { validatePasswordReset, applyPasswordReset } from "@/core/session"
import { notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { Validations } from "@/composables/useValidation";

const instance = getCurrentInstance();

const username = useRoute().query.username?.toString();
const token = useRoute().query.token?.toString();
const isNewAccount = useRoute().query.isNewAccount?.toString();

const proceedToLogin = () => {
  instance!.proxy!.$router.push("/");
};

if (!username || !token) {
  notifyError("Invalid password reset URL");
  proceedToLogin();
}

const passwordResetState = reactive({
  inProgress: false,
  password: "",
  repeatPassword: ""
});

const resetPassword = () => {
  if (!(Validations.notEmpty(passwordResetState.password) && passwordResetState.password.length >= 8 && passwordResetState.password == passwordResetState.repeatPassword)) {
    notifyError("Please make sure the passwords match, and are at least 8 characters long");
    return;
  }
  passwordResetState.inProgress = true;
  
  applyPasswordReset(username!, token!, passwordResetState.password)
  .then(() => {
    notifySuccess("Password reset successfully!");
    proceedToLogin();
  })
  .catch(() => {
    notifyError("Password reset failed");
    passwordResetState.inProgress = false;
  });
};

onMounted(() => {
  passwordResetState.inProgress = true;
  
  validatePasswordReset(username!, token!)
  .then((isValid) => {
    if (isValid) {
      passwordResetState.inProgress = false;
    } else {
      notifyError("Invalid or expired password reset link");
      proceedToLogin();
    }
  })
  .catch((err) => notifyNetworkError("Failed to verify password reset link", err));
})
</script>

<style scoped>
</style>
